var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "grid grid-cols-1 gap-4" }, [
    _c("div", { staticClass: "w-full pt-2 flex-col" }, [
      _c(
        "div",
        { staticClass: "w-full flex flex-col gap-4" },
        [
          _c("diligence-exception-status-dropdown-field", {
            model: {
              value: _vm.statusId,
              callback: function ($$v) {
                _vm.statusId = $$v
              },
              expression: "statusId",
            },
          }),
          _vm._v(" "),
          _c(
            "samc-field",
            { attrs: { label: "Internal Exception Comments:" } },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comments,
                    expression: "comments",
                  },
                ],
                attrs: { rows: "5" },
                domProps: { value: _vm.comments },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.comments = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "samc-field",
            { attrs: { label: "Internal Exception Mitigating Factors:" } },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mitigatingFactors,
                    expression: "mitigatingFactors",
                  },
                ],
                attrs: { rows: "5" },
                domProps: { value: _vm.mitigatingFactors },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.mitigatingFactors = $event.target.value
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-row-reverse pt-4" },
        [
          _c(
            "samc-button",
            {
              on: {
                click: function ($event) {
                  return _vm.reviewExceptions()
                },
              },
            },
            [_vm._v("Update")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }